function getElementWidth(selector) {
  const element = document.querySelector(selector);
  return element?.clientWidth ?? 0;
}

export default getElementWidth;
